export const updateLimitAndPaymentInfo = (payload) => {
  return {
    type: "UPDATE_LIMIT_AND_PAYMENT_INFO",
    payload,
  };
};

export const resetLimitAndPaymentInfo = () => {
  return {
    type: "RESET_LIMIT_AND_PAYMENT_INFO",
  };
}; 

export const updateInsuranceSelection = (payload) => {
  return {
    type: "UPDATE_INSURANCE_SELECTION",
    payload
  };
}; 